import { toast as reactHotToast } from "react-hot-toast";
import { X, CircleX, Copy } from "lucide-react";
import success from "../dev/Success.png";

export const useCustomToaster = () => {
  return {
    success: (message) => {
      reactHotToast.dismiss();
      reactHotToast((t) => (
        <div className="alertToast show">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <img src={success} className="img-fluid" alt="success" />
              <span>{message}</span>
            </div>
          </div>
        </div>
      ));
    },
    error: (message) => {
      reactHotToast.dismiss();
      reactHotToast((t) => (
        <div className="alertToast show">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <CircleX color="red" />
              <span>{message || "Network failed Please Try Again"}</span>
            </div>
          </div>
        </div>
      ));
    },
    copy: (message) => {
      reactHotToast.dismiss();
      reactHotToast((t) => (
        <div className="alertToast show">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <Copy color="white" size={20} />
              <span>{message}</span>
            </div>
            <div>
              <button
                className="closeToastBtn"
                onClick={() => reactHotToast.dismiss(t.id)}
              >
                <X color="white" size={15} />
              </button>
            </div>
          </div>
        </div>
      ));
    },
    toastSuccess: (message) => {
      reactHotToast.dismiss();
      return reactHotToast.success(message, { id: message });
    },
    toastError: (message) => {
      reactHotToast.dismiss();
      return reactHotToast.error(message, { id: message });
    },
    copyToClipboard: async (text, val) => {
      if (!text) {
        return reactHotToast.error("Empty string couldn't copied.!", {
          id: "invalid input",
        });
      }
      if (navigator.clipboard && navigator.permissions) {
        reactHotToast.success(`${val} copied`, { id: val });
        return await navigator.clipboard.writeText(text);
      }
    },
  };
};
